import { ADMIN_COLORS } from '../../../theme';

export const COLORS = {
  border: ADMIN_COLORS.border,
  faint: ADMIN_COLORS.textFaint,
  text: ADMIN_COLORS.textSecondary,
  accent: ADMIN_COLORS.accent,
  accentHover: ADMIN_COLORS.accentHover,
  accentSoft: ADMIN_COLORS.accentSoft,
  danger: ADMIN_COLORS.danger,
  dangerHover: '#b91c1c',
  hoverBg: ADMIN_COLORS.hover,
  surface: ADMIN_COLORS.surface,
  toolbarBg: ADMIN_COLORS.headBg,
};

export const OPTION_TOOLBAR = {
  options: ['inline', 'colorPicker', 'link', 'remove', 'history'],
  inline: {
    inDropdown: false,
    options: [
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'superscript',
      'subscript',
    ],
  },
  colorPicker: {
    colors: [
      '#111827',
      '#374151',
      '#6b7280',
      '#dc2626',
      '#ea580c',
      '#ca8a04',
      '#16a34a',
      '#0891b2',
      '#2563eb',
      '#4f46e5',
      '#9333ea',
      '#db2777',
      '#ffffff',
    ],
  },
  link: {
    defaultTargetOption: '_blank',
    options: ['link', 'unlink'],
  },
};
